import { Component, OnInit, HostListener } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { AuthenticationService, DialogService } from '../../_services';
import { RouteNavigationService } from '../../_services/routeNavigationService';
import { LayoutService } from '../layoutService';

@Component({
  selector: 'fullscrn',
  templateUrl: './fullscrn-layout.html',
})
export class FullScreenLayout implements OnInit {
  userName = '';
  theme = '';
  isCondensed = false;
  constructor(
    private layoutService: LayoutService,
    private authService: AuthenticationService,
    private dialogService: DialogService,
    private routeNavigationService: RouteNavigationService,
    private translate: TranslateService

  ) { }

  ngOnInit() {
    this.getCurrentTheme();
    this.isCondensed = this.layoutService.getIsCondensed();
  }

  switchTheme() {
    this.layoutService.switchTheme();
    this.getCurrentTheme();
  }

  getCurrentTheme() {
    this.theme = this.layoutService.getCurrentThemeMode();
  }

  logout() {
    this.dialogService.showConfirmDialog({
      cssCls: 'testCustom',
      header: this.translate.instant('LABELS.LOGOUT_OF_APP'),
      message: this.translate.instant('MESSAGES.PLEASE_CONFIRM'),
      cancel: this.translate.instant('LABELS.CANCEL'),
      ok: this.translate.instant('LABELS.OK')

    }).then((res) => {
      if (res) {
        this.authService.logout();
        this.routeNavigationService.navigateRoot('/signin');
      }
    });
  }

  onToggleMobileMenu(event) {
    this.layoutService.toggleSidebar();
    this.isCondensed = this.layoutService.getIsCondensed();
  }

}
